import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'cp-purchase-orders',
    templateUrl: './purchase-orders.component.html',
    styleUrls: ['./purchase-orders.component.scss'],
    standalone: false
})
export class PurchaseOrdersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
